import State from './interface';

export default <State>{
    favoriteProperties: [],
    isLoggedIn: false,
    name: '',
    currentProperty: null,
};
